import { Flex, Row } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import WarningAlertIcon from '../../../../../images/warning_alert_orange.svg';

export const ProfessionalInfoSection = ({
  title,
  value,
  isSameLine = false,
  showWarningIcon = false,
}) => (
  <Flex
    direction={isSameLine ? 'row' : 'column'}
    gap={isSameLine ? 2 : 1}
    align={isSameLine ? 'center' : 'start'}
  >
    <Row gap={2} align="center" style={{ alignSelf: 'flex-start' }}>
      <b style={{ color: colors.neutral[600], fontSize: 20 }}>{title}:</b>
      {showWarningIcon ? <img src={WarningAlertIcon} alt="Warning Alert Icon" width={18} /> : null}
    </Row>

    <span
      style={{
        fontSize: 16,
        color: colors.neutral[600],
        ...(isSameLine && {
          flex: 1,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }),
      }}
    >
      {value}
    </span>
  </Flex>
);
